import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';

import ButtonBar, { Button } from '../../ButtonBar';

import RetroButton from '@g4/boneyard/lib/Button'; //'../../../Button/styled/retro';

const propTypes = {
  /**
   * How the children of this component should align themselves within this container.
   * Ignored on small viewports.
   */
  align: PropTypes.oneOf(['default', 'sides', 'left', 'right', 'column']),
};

const defaultProps = {
  align: 'default',
};

/** @visibleName Retro */
const RetroButtonBar = styled(ButtonBar)`
  display: flex;
  flex-wrap: wrap;
  flex-shrink: 0;
  flex-direction: column;
  justify-content: space-around;
  align-content: center;
  text-align: center;
  width: 100%;
  padding: 0 ${props => props.theme.spacing(2)};

  ${Button} {
    width: 100%;
  }

  ${Button} + ${Button} {
    margin-top: ${props => props.theme.spacing(2)};
  }

  ${RetroButton} {
    flex: 1 0 auto; /* GMOB2-110: Fixes Safari display bug */
    width: 100%;
    max-width: 280px;
    text-align: center;
  }

  ${props => props.theme.query.sm} {
    ${props =>
      props.align !== 'column' &&
      css`
      text-align: inherit;
      flex-direction: row;

      ${Button} + ${Button} {
        margin-top: 0;
      }
    `}

    ${props =>
      props.align === 'sides' &&
      css`
        justify-content: space-between;
      `}

    ${props =>
      props.align === 'left' &&
      css`
        justify-content: flex-start;
      `}

    ${props =>
      props.align === 'right' &&
      css`
        justify-content: flex-end;
      `}

    ${Button} {
      width: auto;
    }

    ${RetroButton} {
      width: auto;
    }
  }
`;

RetroButtonBar.propTypes = propTypes;
RetroButtonBar.defaultProps = defaultProps;

/** @component */
export default RetroButtonBar;
